import React, {useEffect, useRef} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useState } from 'react'
import MeChildHeader from '../../components/me-child-header'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import MeLoading from '../../components/loading'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { useStore } from 'react-redux'
import { useQuery } from '../../../../hooks/common'
import { action_fetch_activity_notification, action_fetch_notification_no_read, action_fetch_others_notification, action_fetch_promo_notification, action_fetch_ticket_notification } from '../../../../../store/actions/pages/customer'
import { Iconfont } from '../../../../components/icon/iconfont'
import NotificationTabs from './components/notification-navs'
import NotificationList from './components/notification-list'

const OtherNotifications = props => {
    useStyles(classes)
    const {notificationNoRead, history, Intl} = props

    const goTo = url => {
        history.push(url)
    }

    return (
        <div className={classes.OtherNotifications}>
            <div className={classes.OtherItem} onClick={() => goTo('/user/notification/ticket')}>
                <Iconfont className={classes.OtherIcon}>&#xe6e8;</Iconfont>
                <span className={classes.OtherTxt}>{Intl.formatMessage({id: 'ticket'})}</span>
                {
                    notificationNoRead?.ticket > 0 ?
                    <span className={classes.OtherNoRead}></span>:
                    <React.Fragment></React.Fragment>
                }
            </div>

            <div className={classes.OtherItem} onClick={() => goTo('/user/notification/orders')}>
                <Iconfont className={classes.OtherIcon}>&#xe6ee;</Iconfont>
                <span className={classes.OtherTxt}>{Intl.formatMessage({id: 'orders'})}</span>
                {
                    notificationNoRead?.orders > 0 ?
                    <span className={classes.OtherNoRead}></span>:
                    <React.Fragment></React.Fragment>
                }
            </div>

            <div className={classes.OtherItem} onClick={() => goTo('/user/notification/news')}>
                <Iconfont className={classes.OtherIcon}>&#xe774;</Iconfont>
                <span className={classes.OtherTxt}>{Intl.formatMessage({id: 'news'})}</span>
                {
                    notificationNoRead?.news > 0 ?
                    <span className={classes.OtherNoRead}></span>:
                    <React.Fragment></React.Fragment>
                }
            </div>
        </div>
    )
}

const Notification = props => {
    useStyles(classes);
    const pageCustomer = useSelector(state => state.pageCustomer)
    const { notificationNoRead, customer, notifications, notificationLoading, notificationFinished } = pageCustomer || {}

    const dispatch = useDispatch()
    const Intl = useIntl()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()

    const [showType, setShowType] = useState('activity')
    const showTypeRef = useRef('activity')
    const [loading, setLoading] = useState(true)
    const [dataList, setDataList] = useState([])


    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            await Notification.fetchData(store, params, query)
		}
    }, [])

    useEffect(() => {
        if(notifications?.[showType]?.length >0 || notificationFinished?.[showType]){
            setLoading(false)
            setDataList(notifications[showType])
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 3000)
        }
    }, [notifications, showType])

    useEffect(() => {
        console.log(showTypeRef.current)
    }, [showTypeRef.current])

    const changeShowType = (type) => {
        if(type == showType)return
        setShowType(type)
        showTypeRef.current = type
        setLoading(true)
        switch(type){
            case 'activity':
                dispatch(action_fetch_activity_notification(0)).then(res => {
                    setLoading(false)
                })
                break;
            case 'promo':
                dispatch(action_fetch_promo_notification(0)).then(res => {
                    setLoading(false)
                })
                break;
            case 'others':
                dispatch(action_fetch_others_notification()).then(res => {
                    setLoading(false)
                })
                break;
            default:
                dispatch(action_fetch_activity_notification(0)).then(res => {
                    setLoading(false)
                })
                break;
        }
    }


    return <div className={classes.NotificationPage}>
        <MeChildHeader name={Intl.formatMessage({id: 'message'})}/>

        <NotificationTabs
            showType={showType}
            setShowType={(e) => changeShowType(e)}
            notificationNoRead={notificationNoRead}
            />
        {
            showType == 'others' ?
            <OtherNotifications
                history={history}
                notificationNoRead={notificationNoRead}
                Intl={Intl}
                />:
            <NotificationList
                showType={showType}
                notifications={dataList}
                loading={notificationLoading?.[showType]}
                finished={notificationFinished?.[showType]}
                hideFinishedTxt={true}
                request={() => {
                    if(showType == 'activity'){
                        dispatch(action_fetch_activity_notification())
                    } else if(showType == 'promo'){
                        dispatch(action_fetch_promo_notification())
                    }
                }}
                />
        }

        <MeLoading loading={loading} />
    </div>
}


Notification.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_notification_no_read(headers))
    await store.dispatch(action_fetch_activity_notification(0, headers))
}

export default Notification
